import React, { Component } from "react";
import { withRouter, matchPath } from "react-router";
import PropTypes from "prop-types";

// import { Helmet } from "react-helmet";

import * as ROUTES from "../../../constants/routes.js";

import CareersPage from "../../../pages/CareersPage";
// ^^ Temporary:
//      We'll load this page as a child of this component.

import "./style.scss";

class PopupPages extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: null,
      popupUnderlayExists: false,
      popupUnderlayActive: false,
      popupPageOpen: false,
      popupPageExists: false,
      popupPagePlaced: false,
      popupPageMinHeight: 0,
      popupPageOffsetY: 0,
      pageParams: {},
      homeOffsetY: 0,
      homeContentExists: true,
      careers_roleId: null,
      disable3D: false,
    };

    this.vars = {
      prevHomeScroll: 0,
      homeOffsetY: 0,
      currentPageTransition: null,
    };
  }

  componentDidMount() {
    window.addEventListener("keydown", this.onKeyDown);
    window.addEventListener("popstate", this.onPopstate);
  }

  componentWillUnmount() {
    if (typeof window !== `undefined`) {
      window.removeEventListener("keydown", this.onKeyDown);
      window.removeEventListener("popstate", this.onPopstate);
    }
  }

  componentDidUpdate(prevProps) {
    var Z = this;
    /* if (this.props.location.pathname !== prevProps.location.pathname) {
            Z.pageChanged();
        } */
    if (this.props.currentRoute !== prevProps.currentRoute) {
      Z.pageChanged();
    }
  }

  init = () => {
    const Z = this;

    Z.doResize();

    Z.pageChanged();
  };

  onKeyDown = (event) => {
    if (event.keyCode == 27) {
      this.goBack();
    }
  };

  onPopstate = (event) => {
    // Listens for browser back button, etc.
    // Our "Link" element also triggers a "popstate" event on click.
    const Z = this;
    Z.pageChanged();
  };

  pageChanged = (newPath) => {
    const Z = this;

    /* console.log(
      "window.history.scrollRestoration",
      window.history.scrollRestoration
    );
    console.log(
      "this.props.history.scrollRestoration",
      this.props.history.scrollRestoration
    );

    var currentScrollPosition = 1000;

    const preventScroll = function (event) {
      // console.log("SCROLL detected:", event);
      // window.scrollTo(0, currentScrollPosition);
      Z.setScroll(currentScrollPosition);
    };

    window.addEventListener("scroll", preventScroll);

    window.removeEventListener("scroll", preventScroll); */

    newPath = newPath || window.location.pathname;

    var currentRoute = Z.props.currentRoute;

    var currentPage = currentRoute.path;
    var roleId = currentRoute.params.roleId;

    if (currentPage == "/") {
      currentPage = null;
    }

    var needsPageOpen = null,
      needsPageClose = null,
      needsPageChange = null;
    if (Z.state.currentPage != currentPage) {
      if (currentPage == null && Z.state.currentPage != null) {
        needsPageClose = true;
      } else if (currentPage != null && Z.state.currentPage == null) {
        needsPageOpen = true;
      } else if (currentPage != null && Z.state.currentPage != null) {
        needsPageChange = true;
      }
    }

    var newCloseBtnType = "exit";
    if (needsPageOpen || needsPageChange) {
      const getRouteRootness = Z.props.isRoot && Z.props.isRoot[currentPage];
      if (getRouteRootness == false) {
        newCloseBtnType = "back";
      }
    }
    if (needsPageClose) {
      newCloseBtnType = null;
    }
    // console.log("Z.props.isRoot:", Z.props.isRoot);
    // console.log("Z.props.isRoot[currentPage]:", Z.props.isRoot && Z.props.isRoot[currentPage]);
    // console.log("newCloseBtnType:", newCloseBtnType);
    // console.log("OLD type:", Z.props.closeButtonType);
    if (newCloseBtnType != Z.props.closeButtonType) {
      setTimeout(function () {
        Z.props.setCloseButtonType(newCloseBtnType);
      }, 0);
    }

    /* if (needsPageOpen) {
      Z.setState({ popupUnderlayExists: true }, () => {
        setTimeout(() => {
            Z.setState({ popupUnderlayActive: true });
        }, 10);
    })
      });
  });
    } else if (needsPageClose) {
      Z.setState({ popupUnderlayExists: false, popupUnderlayActive: false });
  } */

    /* var openDelay = 0;
    var openPopupState02Delay = 0;
    var popupState01 = {};
    var popupState02 = {};
    if (needsPageOpen) {
      openPopupState02Delay = 0.02;
      openDelay = 0.12;
      popupState01 = { popupUnderlayExists: true };
      popupState02 = { popupUnderlayActive: true };
    } else if (needsPageClose) {
      popupState01 = { popupUnderlayExists: false, popupUnderlayActive: false };
      // Z.setState({ popupUnderlayExists: false, popupUnderlayActive: false });
    }

    Z.setState(popupState01, () => {
      setTimeout(() => {
        Z.setState(popupState02, () => {
          setTimeout(() => { */
    // console.log(" --> popupState01:", popupState01);
    // console.log(" --> popupState02:", popupState02);

    var popupPageExists = false,
      popupPageOpen = false,
      popupPagePlaced = false,
      currentPageState = null,
      currentParamsState = {};

    if (needsPageOpen) {
      popupPageExists = true;
      popupPageOpen = false;
      popupPagePlaced = false;
      currentPageState = Z.state.currentPage;
      currentParamsState = Z.state.pageParams;
      Z.vars.prevHomeScroll = Z.getScroll();
    } else if (needsPageClose) {
      popupPageExists = true;
      popupPageOpen = false;
      popupPagePlaced = false;
      currentPageState = Z.state.currentPage;
      currentParamsState = Z.state.pageParams;
    } else if (needsPageChange) {
      popupPageExists = true;
      popupPageOpen = true;
      popupPagePlaced = true;
      currentPageState = currentPage;
      currentParamsState = currentRoute.params;
    } else {
      // Handle non-transitions
      if (currentPage == null) {
        popupPageExists = false;
        popupPageOpen = false;
        popupPagePlaced = false;
        currentPageState = currentPage;
        currentParamsState = currentRoute.params;
      } else if (currentPage != null) {
        popupPageExists = true;
        popupPageOpen = true;
        popupPagePlaced = true;
        currentPageState = currentPage;
        currentParamsState = currentRoute.params;
      }
    }

    var pageTransitionTime = 0.5; // Make sure this matches the CSS transition

    Z.vars.currentPageTransition = Z.makeShortId(16); // Unique identifier to help the system not confuse quick page returns
    const pageTransitionID = Z.vars.currentPageTransition;

    var pageScrollPos = 0,
      homeOffsetY = 0;
    if (needsPageClose) {
      pageScrollPos = Z.getScroll();

      if (Z.props.updateBackButton != null) {
        Z.props.updateBackButton({ isActive: false });
      }

      homeOffsetY = -Z.vars.prevHomeScroll;
      Z.setScroll(0);
    } else if (needsPageOpen) {
      //
    }

    // console.log("needsPageOpen", needsPageOpen);
    // console.log("needsPageClose", needsPageClose);
    // console.log("needsPageChange", needsPageChange);

    Z.vars.homeOffsetY = homeOffsetY;

    Z.props.home.setState({
      homeOffsetY: Z.vars.homeOffsetY,
      homeContentExists: true,
    });
    Z.setState(
      {
        popupPageOffsetY: -pageScrollPos,
        popupPageMinHeight: Z.getDocHeight(),
        careers_roleId: roleId,
      },
      () => {
        if (needsPageClose) {
          // Z.setScroll(0);
          // Z.setScroll(Z.vars.prevHomeScroll);
        }
        Z.setState(
          {
            currentPage: currentPageState,
            pageParams: currentParamsState,
            popupPageExists: popupPageExists,
            popupPageOpen: popupPageOpen,
            popupPagePlaced: popupPagePlaced,
          },
          () => {
            if (needsPageOpen) {
              setTimeout(() => {
                Z.setState(
                  {
                    popupPageOpen: true,
                    currentPage: currentPage,
                    pageParams: currentRoute.params,
                    disable3D: true,
                  },
                  () => {
                    setTimeout(() => {
                      Z.setScroll(-Z.vars.homeOffsetY);
                      if (pageTransitionID == Z.vars.currentPageTransition) {
                        Z.props.home.setState({
                          homeContentExists: false,
                        });
                        Z.setState({
                          popupPagePlaced: true,
                          popupPageMinHeight: 0,
                          disable3D: false,
                        });
                        if (Z.props.updateBackButton != null) {
                          Z.props.updateBackButton({ isActive: true });
                        }
                      }
                    }, pageTransitionTime * 1000);
                  }
                );
              }, 0);
            } else if (needsPageClose) {
              setTimeout(() => {
                if (pageTransitionID == Z.vars.currentPageTransition) {
                  Z.props.home.setState({
                    homeOffsetY: 0,
                  });
                  Z.setState(
                    {
                      popupPageExists: false,
                      currentPage: currentPage,
                      pageParams: currentRoute.params,
                      popupPageOffsetY: 0,
                    },
                    () => {
                      Z.setScroll(-Z.vars.homeOffsetY);
                    }
                  );
                }
              }, pageTransitionTime * 1000);
            } else if (needsPageChange) {
              setTimeout(() => {
                Z.setState(
                  {
                    popupPageOpen: true,
                    currentPage: currentPage,
                    pageParams: currentRoute.params,
                  },
                  () => {
                    setTimeout(() => {
                      // Z.setScroll(-Z.vars.homeOffsetY);
                      // NOTE: ^^ Scroll is handled in CareersPage
                      if (pageTransitionID == Z.vars.currentPageTransition) {
                        Z.props.home.setState({
                          homeContentExists: false,
                        });
                        Z.setState({
                          popupPagePlaced: true,
                          popupPageMinHeight: 0,
                        });
                      }
                    }, pageTransitionTime * 1000);
                  }
                );
              }, 0);
            }
          }
        );
      }
    );
    /* }, openDelay * 1000);
        });
      }, openPopupState02Delay * 1000);
  }); */
  };

  /* routeMatch = ({ route, path }) => {
        const Z = this;

        path = path || Z.props.location.pathname;

        const match = matchPath(path, {
            path: route,
            exact: false,
            strict: false
        });

        var returnObj = {};
        if (match != null) {
            const isMatch = match.path == route;

            returnObj = {
                isMatch: isMatch,
                isExact: match.isExact,
                params: match.params,
                path: match.path,
                url: match.url
            };
        } else {
            returnObj = {
                isMatch: false,
                isExact: null,
                params: null,
                path: null,
                url: null
            };
        }

        return returnObj;
    }; */

  makeShortId = (length) => {
    var result = "";
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  getScroll = () => {
    return document.documentElement.scrollTop || document.body.scrollTop;
  };

  setScroll = (pos) => {
    document.documentElement.scrollTop = document.body.scrollTop = pos;
  };

  getDocHeight = () => {
    var body = document.body,
      html = document.documentElement;

    var height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

    return height;
  };

  goBack = () => {
    const Z = this;

    window.history.back();
  };

  render() {
    const Z = this;
    return (
      <>
        <div className={`popup-page-underlay ${Z.state.popupUnderlayExists ? "exists" : ""} ${Z.state.popupUnderlayActive ? "active" : ""}`}></div>
        <div
          className={`PopupPages ${Z.state.popupPageExists ? "exists" : ""} ${Z.state.popupPageOpen ? "open" : ""} ${Z.state.popupPagePlaced ? "placed" : ""}`}
          style={{
            marginTop: `${Z.state.popupPageOffsetY}px`,
            minHeight: `${Z.state.popupPageMinHeight}px`,
          }}
        >
          <div className="popup-page-content-row">
            <div className="popup-page-content">
              {Z.props.pages.map((page, pageIndex) => {
                function testPageMatch() {
                  var isMatch = false;
                  var route;
                  for (var routeKey in page.routes) {
                    route = page.routes[routeKey];
                    if (Z.state.currentPage == route) {
                      isMatch = true;
                    }
                  }
                  return isMatch;
                }

                var pageContent = page.content;

                return (
                  <div
                    className={`popup-page careers-page ${Z.state.disable3D == true ? "disable3D" : ""}`}
                    key={pageIndex}
                    style={{
                      display: testPageMatch() ? "flex" : "none",
                    }}
                  >
                    {page.content}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </>
    );
  }
}

PopupPages.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
  currentRoute: PropTypes.object,
  home: PropTypes.object,
  pages: PropTypes.arrayOf(PropTypes.object),
  updateBackButton: PropTypes.func,
};

export default withRouter(PopupPages);
